import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import type { ApiResponse, PageInfo, ProductVariant } from '../../models';

/** Public Bazaar HTTP endpoints. Storefront state, mapping and SSR stay in the app. */
@Injectable({ providedIn: 'root' })
export class BazaarStorefrontApiService {
  private readonly baseUrl: string;

  constructor(private readonly http: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') version: string) {
    this.baseUrl = `${apiUrl}/api/${version}`;
  }

  page<T>(path: string, page: number, limit: number, params: Record<string, string> = {}) {
    return this.http.get<ApiResponse<{ records: T[]; pagination: PageInfo }>>(`${this.baseUrl}/${path}`, {
      params: { page, limit, ...params }
    });
  }

  categoryTree<T>() {
    return this.http.get<ApiResponse<T[]>>(`${this.baseUrl}/category/tree`);
  }

  bannerTarget(entity: string, id: string | number) {
    return this.http.get<ApiResponse<{ id: string | number; slug?: string }>>(
      `${this.baseUrl}/${entity}/${encodeURIComponent(id)}`
    );
  }

  productVariant(id: string | number) {
    return this.http.get<ApiResponse<ProductVariant>>(`${this.baseUrl}/product-variant/${encodeURIComponent(id)}`);
  }

  priceRange<T>() {
    return this.http.get<ApiResponse<{ records: T[] }>>(`${this.baseUrl}/bazaar-price-range/price`);
  }
}
